import './identity-easy/identity-easy.module';
import './identity-saml/identity-saml.module';

import * as angular from 'angular';

import { IdentityScimFormComponent } from '~/modules/org-settings/components/identity/identity-scim-form/identity-scim-form.component';
import { IdentityScimToggleComponent } from '~/modules/org-settings/components/identity/identity-scim-toggle/identity-scim-toggle.component';
import { IdentityScimModule } from '~/modules/org-settings/components/identity/identity-scim/identity-scim.module';

import { IdentityProviderToggleComponent } from './identity-provider-toggle/identity-provider-toggle.component';
import { IdentityComponent } from './identity.component';
import { IdentityRoutesConfig } from './identity.routes';
import { IdentityService } from './identity.service';

angular
  .module('identity', ['identity-saml', 'identity-easy', IdentityScimModule])
  .config(IdentityRoutesConfig)
  .component('identity', IdentityComponent)
  .component('identityScimForm', IdentityScimFormComponent)
  .component('identityScimToggle', IdentityScimToggleComponent)
  .component('identityProviderToggle', IdentityProviderToggleComponent)
  .service('IdentityService', IdentityService);
